(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    // Removing 'paypal' from wallet-configs (instead of only hiding the button)
    // makes shopify-accelerated-checkout-cart drop the PayPal row's reserved space too.
    // Undocumented behavior of Shopify's accelerated checkout component - re-verify after Shopify theme/platform updates.
    const HIDDEN_WALLETS_IN_DRAWER = ['paypal'];

    const stripHiddenWallets = (el) => {
      const raw = el.getAttribute('wallet-configs');
      if (!raw) return;

      let configs;
      try {
        configs = JSON.parse(raw);
      } catch (error) {
        return;
      }
      if (!Array.isArray(configs)) return;

      const filtered = configs.filter((config) => !HIDDEN_WALLETS_IN_DRAWER.includes(config?.name));
      if (filtered.length === configs.length) return;

      el.setAttribute('wallet-configs', JSON.stringify(filtered));
    };

    const isWalletCartInDrawer = (el) =>
      el.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART' && !!el.closest('.cart-drawer__summary');

    const scanForWalletButtons = (root) => {
      if (isWalletCartInDrawer(root)) stripHiddenWallets(root);
      root.querySelectorAll?.('shopify-accelerated-checkout-cart').forEach((el) => {
        if (isWalletCartInDrawer(el)) stripHiddenWallets(el);
      });
    };

    scanForWalletButtons(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.target.closest?.('.cart-drawer__summary')) {
          stripHiddenWallets(mutation.target);
          continue;
        }
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) scanForWalletButtons(node);
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['wallet-configs'],
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
